import * as signalR from "@microsoft/signalr";
import { pushNotification } from "libs/context/notificationBridge";
import { pushServerTime } from "libs/context/serverTimeBridge";

let connection = null;

const applyServerTimeClock = (clock) => {
  if (!clock || typeof clock !== "object") return;
  pushServerTime(clock);
};

export const startNotificationHub = async () => {
  const authUser = JSON.parse(
    localStorage.getItem("authUser")
  );

  if (!authUser) {
    return;
  }

  const token = authUser;

  if (!token) {
    return;
  }

  // Prevent multiple connections
  if (connection) {
    return connection;
  }

  try {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(
        `${process.env.REACT_APP_SOCKET_URL}webNotification`
      )
      .withAutomaticReconnect()
      .build();

    connection.on("ReceiveServerTime", (clock) => {
      applyServerTimeClock(clock);
    });

    connection.on("ReceiveNotification", (data) => {
      // console.log("Notification:", data);
      if (data?.success !== false) {
        pushNotification(data);
      }
    });

    await connection.start();

    // console.log("SignalR Connected");

    const joinClock = await connection.invoke("Join", token);
    applyServerTimeClock(joinClock);

    // console.log("Joined Successfully");

    const syncClock = await connection.invoke("SyncServerTime", token);
    applyServerTimeClock(syncClock);

    return connection;
  } catch (error) {
    console.error(
      "SignalR Error:",
      error
    );
  }
};